var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3237_62504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66701 13.8491C6.08674 13.7175 5.52946 13.4998 5.01367 13.2031",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 2.14844C10.6594 2.45115 11.8428 3.1949 12.6904 4.25791C13.538 5.32092 13.9996 6.64021 13.9996 7.99977C13.9996 9.35934 13.538 10.6786 12.6904 11.7416C11.8428 12.8046 10.6594 13.5484 9.33398 13.8511",
    stroke: "#13DEA1",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05238 11.3921C2.68871 10.8637 2.41251 10.2802 2.23438 9.66406",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.08203 7.00229C2.1887 6.36896 2.39403 5.76896 2.68203 5.21896L2.7947 5.01562",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60547 3.05244C5.22924 2.62304 5.92902 2.31625 6.66747 2.14844",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3237_62504"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressIcon);
export default __webpack_public_path__ + "static/media/ProgressIcon.9df35d79f211eaf90a713c68b7d222ca.svg";
export { ForwardRef as ReactComponent };